// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2EAg6","label":"Completed_label__rKaBs"};